var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51811 1.33319e-07H6.48989C5.118 -7.86656e-06 4.03134 -2.3925e-05 3.1809 0.118078C2.30566 0.239621 1.59725 0.495705 1.03859 1.07275C0.479926 1.64979 0.231989 2.3815 0.114319 3.28553C-2.31286e-05 4.16394 -7.64641e-06 5.28634 1.29828e-07 6.70334V11.3734C1.29828e-07 12.5798 0.715375 13.6137 1.7319 14.0472C1.67958 13.3196 1.67962 12.2988 1.67967 11.4494V7.51797V7.44181C1.67961 6.41647 1.67956 5.53307 1.77164 4.82562C1.87033 4.06744 2.09289 3.34069 2.66359 2.75121C3.2343 2.16172 3.93792 1.93185 4.67195 1.82992C5.35687 1.73481 6.2122 1.73485 7.20484 1.73491L7.27856 1.73492H9.51811L9.59183 1.73491C10.5845 1.73485 11.4379 1.73481 12.1228 1.82992C11.7131 0.758221 10.7013 1.33319e-07 9.51811 1.33319e-07Z",
    fill: "#058FF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79688 7.51707C2.79688 5.33613 2.79688 4.24568 3.45282 3.56815C4.10877 2.89062 5.16451 2.89062 7.27599 2.89062H9.51554C11.627 2.89062 12.6827 2.89062 13.3387 3.56815C13.9947 4.24568 13.9947 5.33614 13.9947 7.51707V11.3725C13.9947 13.5534 13.9947 14.6438 13.3387 15.3214C12.6827 15.9989 11.627 15.9989 9.51554 15.9989H7.27599C5.16451 15.9989 4.10877 15.9989 3.45282 15.3214C2.79688 14.6438 2.79688 13.5534 2.79688 11.3725V7.51707Z",
    fill: "#058FF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.13b5a673cf6d6c4666cf2606dd2ba993.svg";
export { ForwardRef as ReactComponent };